import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import MainLayout from './components/layout/MainLayout'

// Pages
import LoginPage from './pages/login/LoginPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import ShopsPage from './pages/shops/ShopsPage'
import ShopsMapPage from './pages/shops-map/ShopsMapPage'
import ShopDetailPage from './pages/shops/ShopDetailPage'
import SubscriptionsPage from './pages/subscriptions/SubscriptionsPage'
import PlansPage from './pages/plans/PlansPage'
import BillingPage from './pages/billing/BillingPage'
import MoneyLogsPage from './pages/money-logs/MoneyLogsPage'
import FeatureFlagsPage from './pages/feature-flags/FeatureFlagsPage'
import MenuControlPage from './pages/menu-control/MenuControlPage'
import NotificationsPage from './pages/notifications/NotificationsPage'
import SupportPage from './pages/support/SupportPage'
import AdminUsersPage from './pages/admin-users/AdminUsersPage'
import AuditLogsPage from './pages/audit-logs/AuditLogsPage'
import SystemSettingsPage from './pages/system-settings/SystemSettingsPage'
import SystemHealthPage from './pages/system-health/SystemHealthPage'
import AiUsagePage from './pages/ai-usage/AiUsagePage'
import CustomerAnalyticsPage from './pages/customer-analytics/CustomerAnalyticsPage'
import BusinessTypesPage from './pages/master-data/BusinessTypesPage'
import PaymentMethodsPage from './pages/master-data/PaymentMethodsPage'
import SubscriptionPromotionsPage from './pages/subscription-promotions/SubscriptionPromotionsPage'
import ReferrersPage from './pages/referrers/ReferrersPage'
import ConsentsPage from './pages/consents/ConsentsPage'
import AnnouncementsPage from './pages/announcements/AnnouncementsPage'
import UsageAnalyticsPage from './pages/usage-analytics/UsageAnalyticsPage'
import IntegrationsPage from './pages/integrations/IntegrationsPage'
import FinanceReportsPage from './pages/finance-reports/FinanceReportsPage'
import BusinessInsightsPage from './pages/business-insights/BusinessInsightsPage'
import AccountPage from './pages/account/AccountPage'
import ShopPaymentsPage from './pages/shop-payments/ShopPaymentsPage'
import PermissionsPage from './pages/permissions/PermissionsPage'

const App: React.FC = () => {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Protected — wrapped in MainLayout (handles auth check internally) */}
      <Route
        path="/dashboard"
        element={
          <MainLayout>
            <DashboardPage />
          </MainLayout>
        }
      />
      <Route
        path="/customer-analytics"
        element={
          <MainLayout>
            <CustomerAnalyticsPage />
          </MainLayout>
        }
      />
      <Route
        path="/shops"
        element={
          <MainLayout>
            <ShopsPage />
          </MainLayout>
        }
      />
      <Route
        path="/shops/map"
        element={
          <MainLayout>
            <ShopsMapPage />
          </MainLayout>
        }
      />
      <Route
        path="/shops/:id"
        element={
          <MainLayout>
            <ShopDetailPage />
          </MainLayout>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <MainLayout>
            <SubscriptionsPage />
          </MainLayout>
        }
      />
      <Route
        path="/plans"
        element={
          <MainLayout>
            <PlansPage />
          </MainLayout>
        }
      />
      <Route path="/subscription-promotions" element={<MainLayout><SubscriptionPromotionsPage /></MainLayout>} />
      <Route path="/referrers" element={<MainLayout><ReferrersPage /></MainLayout>} />
      <Route path="/consents" element={<MainLayout><ConsentsPage /></MainLayout>} />
      <Route path="/announcements" element={<MainLayout><AnnouncementsPage /></MainLayout>} />
      <Route path="/usage-analytics" element={<MainLayout><UsageAnalyticsPage /></MainLayout>} />
      <Route path="/integrations" element={<MainLayout><IntegrationsPage /></MainLayout>} />
      <Route path="/business-insights" element={<MainLayout><BusinessInsightsPage /></MainLayout>} />
      <Route path="/finance-reports" element={<MainLayout><FinanceReportsPage /></MainLayout>} />
      <Route
        path="/billing"
        element={
          <MainLayout>
            <BillingPage />
          </MainLayout>
        }
      />
      <Route
        path="/money-logs"
        element={
          <MainLayout>
            <MoneyLogsPage />
          </MainLayout>
        }
      />
      <Route
        path="/feature-flags"
        element={
          <MainLayout>
            <FeatureFlagsPage />
          </MainLayout>
        }
      />
      <Route
        path="/menu-control"
        element={
          <MainLayout>
            <MenuControlPage />
          </MainLayout>
        }
      />
      <Route
        path="/notifications"
        element={
          <MainLayout>
            <NotificationsPage />
          </MainLayout>
        }
      />
      <Route
        path="/support"
        element={
          <MainLayout>
            <SupportPage />
          </MainLayout>
        }
      />
      <Route
        path="/admin-users"
        element={
          <MainLayout>
            <AdminUsersPage />
          </MainLayout>
        }
      />
      <Route
        path="/audit-logs"
        element={
          <MainLayout>
            <AuditLogsPage />
          </MainLayout>
        }
      />
      <Route
        path="/system-settings"
        element={
          <MainLayout>
            <SystemSettingsPage />
          </MainLayout>
        }
      />
      <Route
        path="/system-health"
        element={
          <MainLayout>
            <SystemHealthPage />
          </MainLayout>
        }
      />

      <Route
        path="/master-data/business-types"
        element={
          <MainLayout>
            <BusinessTypesPage />
          </MainLayout>
        }
      />

      <Route
        path="/master-data/payment-methods"
        element={
          <MainLayout>
            <PaymentMethodsPage />
          </MainLayout>
        }
      />

      <Route path="/ai-usage" element={<MainLayout><AiUsagePage /></MainLayout>} />
      <Route path="/account" element={<MainLayout><AccountPage /></MainLayout>} />
      <Route path="/shop-payments" element={<MainLayout><ShopPaymentsPage /></MainLayout>} />
      <Route path="/permissions" element={<MainLayout><PermissionsPage /></MainLayout>} />

      {/* 404 fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
